import React, {useEffect, useState} from "react";

import userService from "../../services/user.service";
import {Navigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {clearMessage} from "../../slices/message";
import SubscriptionListItem from "./SubScriptionListItem";
/*
 import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';
*/
const SubscriptionsStripe = () => {
  const STRIPE_SUBMIT_URL = process.env.REACT_APP_API_URL + "/stripe/create-checkout-session";
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [responseCode, setResponseCode] = useState(400);
  const { user: currentUser } = useSelector((state) => state.auth);
  const [clientsSubs, setClientsSubs] = useState([]);
  const [clients, setClients] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedSub, setSelectedSub] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [proration, setProration] = useState(true);

  const dispatch = useDispatch();

  const date = new Date();
  const firstDayOfNextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);
  const unixTimestamp = Math.floor(firstDayOfNextMonth.getTime() / 1000);

  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.accessToken) {
      setAccessToken(user.accessToken);
    }
    
    const fetchData = async () => {
      setLoading(true);
      try {
        const [clientsRes, clientsSubsRes] = await Promise.all([
          userService.getClientList().catch(e => { console.error(e); return {data: []} }),
          userService.getClientsSubs().catch(e => { console.error(e); return {data: []} })
        ]);

        if (clientsRes.data && clientsRes.data instanceof Array) {
          setContent(clientsRes.data);
          setClients(clientsRes.data);
        }

        setClientsSubs(clientsSubsRes.data);
        setResponseCode(200);
      } catch (error) {
        console.error("Error loading initial data:", error);
        setContent(error.message || "Failed to load initial data");
        setResponseCode(400);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  const refreshSubInfo = () => {
    setLoading(true);
    userService.getClientsSubs().then(
        (response) => {
          setClientsSubs(response.data);
          setResponseCode(200);
          setLoading(false);
        },
        (error) => {
          const _content =
              (error.response &&
                  error.response.data) ||
              error.message ||
              error.toString();
        console.log(error);

          setContent(_content);
          setResponseCode(error.response.status);
          setLoading(false);
        }
    );
  }

  const handleCheckboxChange = (event) => {
    setProration(event.target.checked);
  }
  const handleItemSelect = (item) => {
    setSelectedItem(item);
    setSelectedClient(item.oid);
    setSelectedSub(item.subId);
  }

/*
  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedDateString(format(date, "MM-dd-yyyy"));
  }
*/

  return (
      <div className="container-fluid py-4" style={{ background: 'var(--bg-gradient)', minHeight: '100vh' }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Subscriptions (Stripe)</h2>
        </div>

        {responseCode >= 400 && content && (
            <div className="alert alert-danger shadow-sm rounded-3 mb-4" role="alert">
                {(typeof content) === "string" ? content : (content.hasOwnProperty("message") ? content.message : "something wrong")}
            </div>
        )}

        {loading && (!clients || clients.length === 0) && (
            <div className="text-center py-5 mb-4 card border-0 shadow-lg rounded-4 bg-white">
                <div className="card-body py-5">
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <div className="mt-3 text-muted fw-bold">Loading subscription data...</div>
                </div>
            </div>
        )}

        {!loading && (!clients || clients.length === 0) && (
            <div className="card border-0 shadow-lg rounded-4 mb-4 bg-white">
                <div className="card-body text-center py-4 text-muted">
                    <i className="bi bi-info-circle fs-4 d-block mb-2"></i>
                    No eligible clients found for new subscriptions.
                </div>
            </div>
        )}

        {clients && clients.length > 0 && (
            <div className="card border-0 shadow-lg rounded-4 mb-4">
                <div className="card-header bg-white p-4 border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <h5 className="mb-0">Select Client Subscription</h5>
                    {loading && <span className="spinner-border spinner-border-sm ms-3 text-primary"></span>}
                    {selectedItem && (
                        <form action={STRIPE_SUBMIT_URL} method="POST" className="d-flex align-items-center m-0">
                            <input type="hidden" name="sub_id" value={selectedSub} />
                            <input type="hidden" name="client_id" value={selectedClient} />
                            <input type="hidden" name="access_token" value={accessToken} />
                            <input type="hidden" name="time_zone" value={Intl.DateTimeFormat().resolvedOptions().timeZone} />
                            <input type="hidden" name="next_month" value={unixTimestamp} />
                            <div className="form-check me-3 mb-0 d-flex align-items-center">
                                <input className="form-check-input mt-0 me-2" type="checkbox" id="proration" name="proration" checked={proration} onChange={handleCheckboxChange} />
                                <label className="form-check-label text-nowrap" htmlFor="proration">
                                    Start: <strong className="ms-1">{proration ? "Today" : "1st of next month"}</strong>
                                </label>
                            </div>
                            <button id="checkout-and-portal-button" className="btn btn-primary rounded-pill px-4 shadow-sm text-nowrap" type="submit">
                                <i className="bi bi-credit-card me-2"></i>Subscribe
                            </button>
                        </form>
                    )}
                </div>
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="px-4 py-3">Client</th>
                                    <th className="py-3">Subscription</th>
                                    <th className="py-3">Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {clients.map((c, index) => (
                                    <SubscriptionListItem key={c.oid + c.subId} item={c} handleCheck={handleItemSelect}/>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )}

        <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
            <div className="card-header bg-white p-4 border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h5 className="mb-0">Current Subscriptions</h5>
                <button type="button" className="btn btn-outline-primary rounded-pill px-3 shadow-sm" onClick={() => refreshSubInfo()} disabled={loading}>
                    {loading ? (
                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    ) : (
                        <i className="bi bi-arrow-clockwise me-1"></i>
                    )}
                    {loading ? "Refreshing..." : "Refresh"}
                </button>
            </div>
            <div className="card-body p-0">
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                        <thead className="table-light">
                            <tr>
                                <th className="px-4 py-3">Client</th>
                                <th className="py-3">Subscription</th>
                                <th className="py-3">Start Date</th>
                                <th className="py-3">End Date</th>
                                <th className="py-3">Payment ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientsSubs && clientsSubs instanceof Array && clientsSubs.length > 0 ? clientsSubs.map((cs, index) => (
                                <tr key={index}>
                                    <th scope="row" className="px-4">{cs.clientName}</th>
                                    <td><span className="badge bg-info text-dark">{cs.subscriptionName}</span></td>
                                    <td>{cs.startDate}</td>
                                    <td>{cs.endDate}</td>
                                    <td><code className="text-muted">{cs.paymentId}</code></td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="5" className="text-center py-4 text-muted">No subscriptions found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      </div>
  );
};

export default SubscriptionsStripe;
